// Helper and utility functions for Wanderland

// Date formatting
function formatDate(dateStr) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  console.log('[formatDate] input dateStr:', dateStr);
  const monthNum = dateStr.slice(5, 7);
  const month = months[monthNum - 1];
  const year = dateStr.slice(0, 4);

  return month + ' ' + year;
}

// Get trip number from image alt string
function getTripNumber(altStr) {
  return parseInt(altStr.split(',')[0]);
}

// Get image index from image alt string
function getImageIndex(altStr) {
  return parseInt(altStr.split(',')[1]);
}

// Group trips by year and return array of [year, startIndex] pairs
function getYearGroupInfo(tripsList) {
  //console.log('[getYearGroupInfo] input tripsList:', tripsList);
  if (!Array.isArray(tripsList) || tripsList.length === 0) {
    console.log(
      '[getYearGroupInfo] tripsList is empty or not an array:',
      tripsList,
    );
    return [];
  }
  const groups = []
  let currentYear = null;
  let startIndex = 0;
  for (let i = 0; i < tripsList.length; i++) {
    const trip = tripsList[i];

    //Changed from trip.dates to trip.date to match the new data element source
    const year =
      //trip.dates && trip.dates[0] ? trip.dates[0].slice(0, 4) : 'Unknown';
      trip.date && trip.date[0] ? trip.date.slice(0, 4) : 'Unknown';
      
    //console.log("trip.name, trip.dates, trip.date", trip.name,  trip.dates, trip.date);
    //console.log ("year",year);

    if (year !== currentYear) {
      if (currentYear !== null) {
        groups.push([currentYear, startIndex]);
      }
      currentYear = year;
      startIndex = i;
    }
  }
  // Push last group
  if (currentYear !== null) {
    groups.push([currentYear, startIndex]);
  }
  console.log('[getYearGroupInfo] groups result:', groups);
  return groups;
}

module.exports = {
  formatDate,
  getTripNumber,
  getImageIndex,
  getYearGroupInfo,
};
